module.exports = __webpack_public_path__ + "img/welcome-bg.1feb08cb.png";